import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCoffee,
  faChevronDown,
  faUserCircle,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCog,
  faFilter,
  faCalendar,
  faShoppingCart,
  faFileInvoiceDollar,
  faQuestion,
  faPlus,
  faMinus,
  faInfoCircle,
  faCheck,
  faTimes,
  faTrash,
  faPrint,
  faFolder,
  faSpinner,
  faMinusSquare,
  faColumns,
  faEye,
  faLink,
  faFileInvoice,
  faEdit,
  faLongArrowAltRight,
  faExclamationCircle,
  faMapMarkerAlt,
  faSearch,
  faUndo,
  faTicketAlt,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';

import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle';
import { faHandHoldingUsd } from '@fortawesome/pro-regular-svg-icons/faHandHoldingUsd';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faCoffee,
  faChevronDown,
  faUserCircle,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCog,
  faFilter,
  faCalendar,
  faShoppingCart,
  faFileInvoiceDollar,
  faQuestion,
  faPlus,
  faMinus,
  faInfoCircle,
  faCheck,
  faTimes,
  faTrash,
  faPrint,
  faFolder,
  faSpinner,
  faMinusSquare,
  faColumns,
  faEye,
  faLink,
  faEdit,
  faLongArrowAltRight,
  faExclamationCircle,
  faMapMarkerAlt,
  faSearch,
  faUndo,
  faExclamationTriangle,
  faHandHoldingUsd,
  faTicketAlt,
  faEnvelope,
  faFileInvoice
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
